import { Component, Input, OnInit } from '@angular/core';
import { CandidateModel } from '../../models/candidate.model';
import { ObserverModel } from '../../models/observer.model';
import { faStreetView, faUser, faUserTie, faUsers } from '@fortawesome/pro-light-svg-icons';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from '../../services/auth-state.service';

export enum AvatarType {
  Candidate = 'candidate',
  Observer = 'observer',
}

export enum AvatarMode {
  Compact = 'compact',
  Small = 'small',
}

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {

  @Input() user: CandidateModel | ObserverModel;
  @Input() type: AvatarType;
  @Input() mode: AvatarMode;
  @Input() inactive = false;
  @Input() groupModerator = false;
  @Input() showStatus = false;
  @Input() white = false;
  @Input() pointer = false;
  @Input() tooltipPosition: string = 'right';

  public isMe = false;

  public faStreetView = faStreetView;
  public faUsers = faUsers;
  public faUserTie = faUser;
  public AvatarType = AvatarType;
  public AvatarMode = AvatarMode;

  constructor(
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.isMe = this.auth.isMe(this.user.hashed_id);
  }

  public getTooltipName(): string {
    let result = this.user?.fullname;
    if (this.groupModerator === true) {
      result += ' (' + this.transloco.translate('common.labels.groupmoderator') + ')';
    }
    return result;
  }

}
